export default "__VITE_ASSET__CvaYgs4i__"